import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    IconButton,
    Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const Portfolio = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    // Dummy Portfolio Data
    const portfolioItems = [
        {
            id: 1,
            title: "Modern Interior Design Project",
            category: "Interior Design",
            subCategory: "Home Decor",
            thumbnail: "/static/images/placeholder.png",
            completionDate: "15 Aug 2024",
        },
        {
            id: 2,
            title: "Wedding Photography Shoot",
            category: "Photography",
            subCategory: "Weddings",
            thumbnail: "/static/images/placeholder.png",
            completionDate: "22 Sept 2024",
        },
        {
            id: 3,
            title: "Website Redesign for Client",
            category: "Web Development",
            subCategory: "UI/UX Design",
            thumbnail: "/static/images/placeholder.png",
            completionDate: "10 Oct 2024",
        },
    ];

    const filteredItems = portfolioItems.filter((item) =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <div className="main_title">
                <h1>Portfolio Management</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Portfolio Management
                </p>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search portfolio..."
                        />
                    </div>
                    <div className="right_s">
                        <Button
                            className="btn btn_primary"
                            onClick={() => navigate("add")}
                        >
                            <AddIcon /> Add Portfolio
                        </Button>
                    </div>
                </div>

                <TableContainer className="table_container" sx={{ mt: 3 }}>
                    <Table sx={{ minWidth: 750 }} aria-label="portfolio table" className="v3">
                        <TableHead>
                            <TableRow hover>
                                <TableCell>Thumbnail</TableCell>
                                <TableCell>Title of Work</TableCell>
                                <TableCell>Category</TableCell>
                                <TableCell>Sub-category</TableCell>
                                <TableCell>Date of Completion</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredItems.map((item, index) => (
                                <TableRow hover key={index}>
                                    {/* Thumbnail */}
                                    <TableCell>
                                        <div className="user_block">
                                            <figure>
                                                <img
                                                    src={item.thumbnail}
                                                    alt={item.title}
                                                />
                                            </figure>
                                        </div>
                                    </TableCell>

                                    {/* Title */}
                                    <TableCell>
                                        <strong>{item.title}</strong>
                                    </TableCell>

                                    {/* Category */}
                                    <TableCell>{item.category}</TableCell>

                                    {/* Sub-category */}
                                    <TableCell>{item.subCategory}</TableCell>

                                    {/* Completion Date */}
                                    <TableCell>{item.completionDate}</TableCell>

                                    {/* Action Buttons */}
                                    <TableCell>
                                        <Box display="flex" gap={1}>
                                            <IconButton onClick={() => navigate("add")}>
                                                <img
                                                    src="/static/images/edit2_icon.svg"
                                                    alt="Edit"
                                                    style={{ width: "22px", height: "22px" }}
                                                />
                                            </IconButton>
                                            <IconButton>
                                                <img
                                                    src="/static/images/trash2_icon.svg"
                                                    alt="Delete"
                                                    style={{ width: "22px", height: "22px" }}
                                                />
                                            </IconButton>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}

                            {filteredItems.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        No portfolio items found.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
};

export default Portfolio;
